{
  "title": "Charge points: map",
  "searchLocation": "Search location",
  "mapLabel": "Map of public charge points",
  "railLabel": "Map tools",
  "chipsLabel": "Quick filters",
  "chipPinSwitch": "Show price on pins",
  "chipPinOn": "Turn on pin values (kW)",
  "chipPinTitle": "Switch the pin label between kW and price",
  "chipFree": "Available only",
  "chipFrom": "> {n} kW",
  "chipTo": "< {n} kW",
  "filterTitle": "Filters",
  "infoTitle": "About the map",
  "detailsTitle": "Site details",
  "settingsTitle": "Settings",
  "menuTitle": "Menu",
  "menuOpen": "Open menu",
  "menuClose": "Close menu",
  "menuBack": "Back",
  "menuFeedback": "Feedback",
  "menuLegal": "Imprint & privacy",
  "filterClose": "Close filters",
  "detailsClose": "Close site details",
  "menuSoon": "Soon",
  "zoomIn": "Zoom in",
  "zoomOut": "Zoom out",
  "attributionLabel": "Attribution",
  "attributionShow": "Show map attribution",
  "attributionHide": "Hide map attribution",
  "mapTitle": "Map",
  "noInfo": "No information",
  "loading": "Loading site …",
  "detailsUnavailable": "Site currently unavailable.",
  "dataError": "Could not load data.",
  "mapError": "Could not load part of the basemap.",
  "startError": "Could not start the map. Please reload.",
  "occupancy": "Occupancy",
  "price": "Pay-as-you-go price",
  "opening": "Opening hours",
  "dataTime": "Last update",
  "plugs": "Charge points",
  "route": "Directions",
  "lastReported": "Last reported: {date}",
  "freeOf": "{free} of {known} available",
  "noPoints": "No charge points reported",
  "busyCount": "{n} occupied",
  "outCount": "{n} out of service",
  "unknownCount": "{n} unknown",
  "pointCountOne": "{n} charge point",
  "pointCountOther": "{n} charge points",
  "plugUnknown": "Unknown connector",
  "noUpdate": "No update yet",
  "source": "Data: {name}",
  "ageNow": "just now",
  "ageMinutes": "{n} min ago",
  "ageHours": "{n} h ago",
  "ageDaysOne": "{n} day ago",
  "ageDaysOther": "{n} days ago",
  "locating": "Finding your position",
  "locate": "Follow my position",
  "followStop": "Stop following position",
  "myPosition": "My position",
  "noPosition": "This device does not support location.",
  "positionDenied": "Location access denied.",
  "positionUnavailable": "Position currently unavailable. Try again.",
  "all": "All",
  "unlimited": "Unlimited",
  "unknown": "Unknown status",
  "out": "Out of service",
  "filter": "Filters",
  "filterCount": "Filters ({n} active)",
  "powerFrom": "from {n} kW",
  "powerTo": "up to {n} kW",
  "powerRange": "{a}-{b} kW",
  "kw": "{n} kW",
  "legendNone": "None available",
  "legendSome": "Some available",
  "legendAll": "All available",
  "legendPoint": "Individual site at overview zoom",
  "unavailable": "Live updates currently unavailable.",
  "connectors": "Connectors",
  "chargingPower": "Charging power",
  "minimumPower": "Minimum power",
  "maximumPower": "Maximum power",
  "reset": "Reset",
  "done": "Done",
  "legendTitle": "Legend",
  "liveTitle": "Live updates",
  "liveExplanation": "Charge point occupancy updates continuously in the background. There is no need to reload the page.",
  "sources": "Sources",
  "sourceLicense": "Each dataset’s license terms apply.",
  "osmContributors": "© OpenStreetMap contributors (ODbL)",
  "display": "Appearance",
  "light": "Light",
  "dark": "Dark",
  "themeAuto": "Auto",
  "themeAutoHint": "Follows the system setting",
  "data": "Data",
  "liveUpdates": "Live updates",
  "live": "Live",
  "liveSetting": "When enabled, charge point occupancy updates automatically in the background.",
  "language": "Language",
  "auto": "Automatic",
  "autoDetected": "Automatic ({language})",
  "languageDe": "Deutsch",
  "languageEn": "English",
  "languageFr": "Français",
  "languageEs": "Español",
  "noscript": "Please enable JavaScript to use the map.",
  "perKwh": "{amount}/kWh",
  "pricePartial": "Not reported for all charge points",
  "freePrice": "Free of charge",
  "distanceMeters": "{n} m",
  "distanceKilometers": "{n} km",
  "freeCount": "{n} available",
  "staleData": "Status outdated · {age}",
  "noStatusData": "No status data",
  "open247": "Open 24/7",
  "adHoc": "Ad hoc",
  "priceNotReported": "Price not reported",
  "moreInfo": "Details",
  "address": "Address",
  "siteId": "Site ID",
  "dataSource": "Data source",
  "attribution": "<a class=\"credit-tiles\" href=\"https://protomaps.com/\">Protomaps</a> <a class=\"credit-osm\" href=\"https://www.openstreetmap.org/copyright\">© OpenStreetMap</a>",
  "plugType1": "Type 1",
  "plugType2": "Type 2",
  "plugType3C": "Type 3C",
  "operatorLabel": "Operator",
  "distanceAway": "{distance} away",
  "openingChip": "Opening hours: {value}",
  "stateFree": "Available",
  "stateBusy": "Occupied",
  "pointN": "Charge point {n}",
  "pointsList": "Charge points with ID",
  "sourceChargingTitle": "Charge points & occupancy",
  "sourceChargingText": "Operator data published via the German National Access Point Mobilithek (AFIR).",
  "sourceChargingLink": "Mobilithek",
  "sourceBasemapTitle": "Base map",
  "sourceBasemapText": "Map data from OpenStreetMap, tiles in the Protomaps schema, served by where2charge itself.",
  "sourceDisplayTitle": "Map display",
  "sourceDisplayText": "Rendered with the open-source library MapLibre GL JS.",
  "sourceDisplayLink": "MapLibre GL JS (BSD-3-Clause)",
  "liveInfoLabel": "Live updates: show explanation",
  "liveReconnecting": "The live connection is interrupted and reconnects automatically. Until then, occupancy may be out of date.",
  "toastClose": "Dismiss",
  "maxPrice": "Max. price (ad hoc)",
  "maxPriceLabel": "Maximum price per kWh",
  "priceAny": "Any",
  "priceUpTo": "up to {n} ct/kWh",
  "priceFilterBasis": "Filters by energy price per kWh",
  "pricesUnavailable": "Prices could not be loaded; the price filter is unavailable right now.",
  "lastChange": "Last change {age}",
  "unchangedFor": "Unchanged for {span}",
  "lastReport": "Last update received {age}",
  "spanMinutes": "{n} min",
  "spanHours": "{n} h",
  "spanDaysOne": "{n} day",
  "spanDaysOther": "{n} days",
  "pointSince": "for {span}",
  "pointSinceOver": "for {span}",
  "ctPerKwh": "{n} ct/kWh",
  "ctPerMin": "{n} ct/min",
  "sessionFee": "{amount} per session",
  "timeFee": "time fee {amount}",
  "idleFee": "idle fee {amount} from {span} after charging ends",
  "lateFee": "one-off {amount} from {span}",
  "fromSpan": "from {span}",
  "untilSpan": "until {span}",
  "capAmount": "max {amount}",
  "certainHours": "certain hours only",
  "sessionMin": "min {amount} per session",
  "sessionMax": "max {amount} per session",
  "variesTime": "varies by time of day",
  "variesDuration": "varies with duration",
  "hitsChipOne": "{n} search result",
  "hitsChipOther": "{n} search results",
  "hitsClear": "Clear search results",
  "hitLabel": "Search result {rank}",
  "languageIt": "Italiano",
  "languageNl": "Nederlands",
  "languagePl": "Polski",
  "languagePt": "Português",
  "languageSv": "Svenska",
  "languageCs": "Čeština",
  "spanMinutesOne": "{n} min",
  "spanMinutesOther": "{n} min",
  "spanHoursOne": "{n} h",
  "spanHoursOther": "{n} h",
  "spanMinutesFew": "{n} min",
  "spanMinutesMany": "{n} min",
  "spanHoursFew": "{n} h",
  "spanHoursMany": "{n} h",
  "spanDaysFew": "{n} days",
  "spanDaysMany": "{n} days",
  "ageDaysFew": "{n} days ago",
  "ageDaysMany": "{n} days ago",
  "pointCountFew": "{n} charge points",
  "pointCountMany": "{n} charge points",
  "hitsChipFew": "{n} search results",
  "hitsChipMany": "{n} search results",
  "freeShort": "{free}/{known} free",
  "share": "Share",
  "shareTitle": "Share this site",
  "linkCopied": "Link copied",
  "copyFailed": "Could not copy the link",
  "pricesTitle": "Prices",
  "pricesExplanation": "Prices are pay-as-you-go prices without a contract, as reported by the operator. Contract and subscription prices are not included and may differ.",
  "feeEnergy": "Energy",
  "feeSession": "Per session",
  "feeTime": "Time fee",
  "feeIdle": "Idle fee",
  "feeLate": "One-off fee",
  "feeSessionMax": "At most per session",
  "feeSessionMin": "At least per session",
  "idleAfterEnd": "after charging ends",
  "idleFromAfterEnd": "from {span} after charging ends",
  "otherTimes": "other times",
  "hoursRange": "{from}–{to}",
  "stateUnknownShort": "Unknown",
  "siteUpdateInfo": "Newest actual reception of site data: {age}. Provider timestamps and occupancy changes are independent.",
  "pointSinceNow": "< 1 min",
  "pointTimestampInfo": "Point status received: {received}. Provider timestamp: {provider}; not a proven occupancy change.",
  "timeExamples": "Time examples (not live data)",
  "siteTimeExplanation": "Shows when we last received data for this site.",
  "pointTimeExplanation": "Shows how long the point has been reported to us as available or occupied.",
  "exampleSiteTime": "Last update 3 hours ago",
  "placeLabel": "City",
  "chargingStart": "from the start of charging",
  "chargingFrom": "after {span} of charging",
  "stateFreeShort": "Free",
  "stateBusyShort": "In use",
  "stateOutShort": "Offline",
  "detailOpening": "Hours",
  "detailPrice": "Ad-hoc price",
  "detailSource": "Data source",
  "detailUpdated": "Updated",
  "detailAccess": "Access",
  "detailSiteId": "Site ID",
  "pinSecondary": "Pin extra value",
  "pinKw": "kW",
  "pinPrice": "Price",
  "pinOff": "Off",
  "idCopied": "ID copied",
  "idCopyFailed": "Could not copy ID",
  "variesDays": "varies by weekday",
  "variesTimeDays": "varies by time and weekday",
  "variesMultiple": "multiple prices",
  "moreFees": "+{n} more fees",
  "copied": "Copied",
  "copyFailedShort": "Not copied",
  "copyIdHint": "Press and hold, or press Enter, to copy the ID.",
  "legendBadge": "Value below the pin: charging power or price, selectable in Settings",
  "mapLoading": "Loading map…",
  "mapRetry": "Retry",
  "onlyFree": "Show available only",
  "hideOutOfService": "Hide out of service",
  "powerChipDc": "Blue = DC fast charging",
  "powerChipExamples": "Power chip examples",
  "searchLabel": "Search for a place",
  "searchPlaceholder": "Search place or address",
  "searchBack": "Back to map",
  "searchClear": "Clear search",
  "searchSuggestions": "Suggestions",
  "searchNoResults": "No places found",
  "searchUnavailable": "Search is unavailable right now",
  "searchResultsOne": "{n} suggestion",
  "searchResultsOther": "{n} suggestions",
  "searchResultsFew": "{n} suggestions",
  "searchResultsMany": "{n} suggestions",
  "searchKindStreet": "Street",
  "searchKindParking": "Parking",
  "searchKindStation": "Station",
  "searchKindCity": "Town",
  "sourceSearchTitle": "Place search",
  "sourceSearchText": "Search: Photon on OpenStreetMap data, run on our own server. Search terms are not passed on to third parties.",
  "searchHint": "Town, address or landmark in Germany",
  "registryAsOf": "Register date {date}",
  "registryStale": "Register data is outdated.",
  "registryChip": "No live updates",
  "registryChipInfo": "Register sites have no live updates.",
  "liveRegisterNote": "Sites from the static charge point register of the Bundesnetzagentur get no live updates (no status, no occupancy, no prices). In the details, you can recognize them by the orange “No live updates” notice.",
  "registryNormalized": "Normalized, grouped into sites and matched against AFIR. No live occupancy or prices. Monthly register; corrections: Bundesnetzagentur.de.",
  "sourceRegistryTitle": "Static charging register",
  "menuConnector": "Connect Grok in your Tesla",
  "menuConnectorSub": "MCP connector",
  "connectorIntro": "Connect where2charge to Grok as a connector. Grok then finds charging sites by voice and shows them on this map.",
  "connectorStepsTitle": "Three steps",
  "connectorStep1": "Sign in to the Grok app or {grok} with your Grok account and open the connector settings.",
  "connectorStep2": "Select “New Connector” → “Custom” and enter the MCP URL. The server requires no login or API key.",
  "connectorStep3": "Sign in to the same Grok account in your Tesla. The connector is available there: ask Grok for charging sites by voice and have it open the results map.",
  "connectorUrlTitle": "MCP URL",
  "connectorCopy": "Copy",
  "connectorCopied": "Copied",
  "connectorExamplesTitle": "Try saying",
  "connectorEx1": "“Search where2charge for available chargers nearby.”",
  "connectorEx2": "“Show me only available CCS chargers above 200 kW.”",
  "connectorEx3": "“What prices does the first result have?”",
  "connectorEx4": "“Show me charging sites at Berlin central station.”",
  "connectorDocs": "Full docs & tool reference",
  "menuNewTab": "Opens in a new tab",
  "menuOpenStandalone": "Open as separate page",
  "menuLoadFailed": "The text could not be loaded.",
  "imprintTitle": "Legal notice",
  "privacyTitle": "Privacy policy",
  "dataNoticeTitle": "Data notice"
}
